import styled from "styled-components";

const StorybookPage = () => {
  return (
    <Container>
      <iframe
        src="https://api.scaptcha.com/storybook/"
        title="storybook"
        frameBorder="0"
      />
    </Container>
  );
};

export default StorybookPage;

const Container = styled.div`
  padding: 0 10px;
  iframe {
    width: 100%;
    height: 800px;
    border-radius: 8px;
    border: 3px solid #559ed6;
  }
`;
